import { useMutation } from '@tanstack/react-query'
import { API_ENDPOINT } from '~/api/utils'

interface ConsentParams {
  approved: boolean
  oauthParams: string
}

export class OAuthConsentError extends Error {
  constructor(
    message: string,
    public readonly status: number
  ) {
    super(message)
  }
}

const submitConsent = async ({
  approved,
  oauthParams
}: ConsentParams): Promise<string> => {
  const jwt = localStorage.getItem('token') ?? ''
  const instance = localStorage.getItem('instance') ?? ''

  const body = new URLSearchParams(oauthParams)
  body.set('consent', approved ? 'approved' : 'denied')

  const response = await fetch(
    `${API_ENDPOINT}/oauth/authorize?${oauthParams}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // Asks the server to return the redirect target as JSON: a fetch()
        // cannot read the Location header of a real redirect response
        Accept: 'application/json',
        'x-JWT': jwt,
        'x-INSTANCE': instance
      },
      body: body.toString()
    }
  )

  if (!response.ok) {
    const data: Record<string, string> = await response.json().catch(() => ({}))
    throw new OAuthConsentError(
      data.message ?? 'Erreur lors de la soumission du consentement',
      response.status
    )
  }

  // The client's redirect_uri, carrying the code or error=access_denied
  const data: { location?: string } = await response.json()
  if (!data.location) {
    throw new OAuthConsentError(
      "L'application n'a pas fourni d'adresse de retour",
      response.status
    )
  }

  return data.location
}

export const useOAuthConsent = () =>
  useMutation({
    mutationFn: submitConsent,
    onSuccess: (location) => {
      window.location.href = location
    }
  })
